// extracted by mini-css-extract-plugin
export default {"post":"PostItem_post__szLGD","btn":"PostItem_btn__5o4ly","input":"PostItem_input__AXAHq"};